export default __webpack_public_path__ + "static/media/emptyTasksCompleted.9a8e486a.png";